import * as moment from "moment";
import { Action, Reducer } from "redux";
import { fetchMyUiLanguage } from "../../api/UserApi";
import { Language, LanguageLocale, LanguageKeys, LocalStorageKey } from "../../data/constants";
import { AppThunkAction } from "../ApplicationStore";
import { SessionState, unloadedState } from "./SessionState";
import { LifeExamSessionLinkRoute } from "../../Routes";
import { getLanguageFromKey } from "../../utils/LanguageHelper";

export interface IChangeLanguageAction {
  type: "CHANGE_LANGUAGE";
  language?: Language;
}

type KnownAction = IChangeLanguageAction;

const setLanguage = (dispatch: (action: KnownAction) => void, language: Language) => {
  moment.locale(LanguageLocale[language]);
  localStorage.setItem(LocalStorageKey.LastSelectedLanguageKey, language);
  dispatch({ type: "CHANGE_LANGUAGE", language });
};

export const ActionCreators = {
  changeLanguage:
    (language: Language): AppThunkAction<KnownAction> =>
    (dispatch) => {
      setLanguage(dispatch, language);
    },
  getAndSetLanguage: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
    if (getState().sessionState.isUserAuthenticated) {
      fetchMyUiLanguage().then((language: Language) => setLanguage(dispatch, language));
    }
  },
  detectLanguageIfPossible: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
    const lastSelectedLanguage: string | null = localStorage.getItem(LocalStorageKey.LastSelectedLanguageKey);
    if (lastSelectedLanguage && lastSelectedLanguage !== "null" && isLanguage(lastSelectedLanguage.toUpperCase())) {
      setLanguage(dispatch, lastSelectedLanguage as Language);
      return;
    }

    let suggestedLanguage = navigator.languages.find(
      (lang) =>
        lang.toUpperCase().startsWith("DE") ||
        lang.toUpperCase().startsWith("FR") ||
        lang.toUpperCase().startsWith("EN")
    );

    if (suggestedLanguage && isLanguage(suggestedLanguage)) {
      suggestedLanguage = suggestedLanguage.substr(0, 2);
      setLanguage(dispatch, suggestedLanguage as Language);
    }

    const lifeRegex = `${LifeExamSessionLinkRoute}/([^/]+)`;
    const languageKey = RegExp(lifeRegex).exec(window.location.pathname)?.[1];
    if (languageKey) {
      var language = getLanguageFromKey(languageKey);
      setLanguage(dispatch, language as Language);
    }
  },
};

const isLanguage = (value: string): value is LanguageKeys => {
  return value in Language;
};

export const reducer: Reducer<SessionState> = (state: SessionState = unloadedState, incomingAction: Action) => {
  const action = incomingAction as KnownAction;

  switch (action.type) {
    case "CHANGE_LANGUAGE": {
      if (action.language) {
        return { ...state, language: action.language };
      }
    }
  }

  return state;
};
